import React, { Component } from "react";
import "./App.css";
import "./css/spacing.css"
import 'antd/dist/antd.css';
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import Home from "./containers/Home";
import Layout from "./containers/Layout/Layout";
const loading = () => <div>Loading...</div>;

class App extends Component {
  render() {
    return (
      <div className="main">
        <Router >
          <React.Suspense fallback={loading()}>
            <Switch>
              <Route path="/home" component={Home} />
              <Route
                path="/"
                name="Home"
                render={props => <Layout {...props} />}
              />
            </Switch>
          </React.Suspense>
        </Router>
      </div>
    );
  }
}
export default App;
